import type { LayoutPaneReactElement } from '../Types/LayoutPaneReactElement'
import { KEYWORD_OUTER_CHILDREN } from '../Panes/types-and-constants/LayoutPaneTypesAndConstants'

export const getInnerChildren = (children: LayoutPaneReactElement[]): LayoutPaneReactElement[] => {
    return children.filter((child) => {
        if (!child?.props?.paneType) {
            console.error('child is not a LayoutPane')
            return false
        }
        return !child?.props?.paneType?.includes(KEYWORD_OUTER_CHILDREN)
    })
}
